import { createSlice } from "@reduxjs/toolkit";

const programSlice = createSlice({
  name: "program",
  initialState: {
    programs: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    // Fetch programs actions
    fetchProgramsStart(state) {
      state.programs.loading = true;
      state.programs.error = null;
    },
    fetchProgramsSuccess(state, action) {
      state.programs.loading = false;
      state.programs.data = action.payload;
    },
    fetchProgramsFailure(state, action) {
      state.programs.loading = false;
      state.programs.error = action.payload;
    },

    // Add program actions
    addProgramStart(state) {
      state.programs.loading = true;
      state.programs.error = null;
    },
    addProgramSuccess(state, action) {
      state.programs.loading = false;
      state.programs.data = [...state.programs.data, action.payload];
    },
    addProgramFailure(state, action) {
      state.programs.loading = false;
      state.programs.error = action.payload;
    },

    // Update program actions
    updateProgramStart(state) {
      state.programs.loading = true;
      state.programs.error = null;
    },
    updateProgramSuccess(state, action) {
      state.programs.loading = false;
      const index = state.programs.data.findIndex(
        (program) => program.id === action.payload.id
      );
      if (index !== -1) {
        state.programs.data[index] = action.payload;
      }
    },
    updateProgramFailure(state, action) {
      state.programs.loading = false;
      state.programs.error = action.payload;
    },

    // Delete program actions
    deleteProgramStart(state) {
      state.programs.loading = true;
      state.programs.error = null;
    },
    deleteProgramSuccess(state, action) {
      state.programs.loading = false;
      state.programs.data = state.programs.data.filter(
        (program) => program.id !== action.payload
      );
    },
    deleteProgramFailure(state, action) {
      state.programs.loading = false;
      state.programs.error = action.payload;
    },

    // Fetch program names actions
    fetchProgramNamesStart(state) {
      state.programs.loading = true;
      state.programs.error = null;
    },
    fetchProgramNamesSuccess(state, action) {
      state.programs.loading = false;
      state.programs.data = action.payload;
    },
    fetchProgramNamesFailure(state, action) {
      state.programs.loading = false;
      state.programs.error = action.payload;
    },
  },
});

export const {
  fetchProgramsStart,
  fetchProgramsSuccess,
  fetchProgramsFailure,
  addProgramStart,
  addProgramSuccess,
  addProgramFailure,
  updateProgramStart,
  updateProgramSuccess,
  updateProgramFailure,
  deleteProgramStart,
  deleteProgramSuccess,
  deleteProgramFailure,
  fetchProgramNamesStart,
  fetchProgramNamesSuccess,
  fetchProgramNamesFailure
} = programSlice.actions;

export default programSlice.reducer;
